import { render, staticRenderFns } from "./Highlighter.vue?vue&type=template&id=5e852b18&scoped=true"
import script from "./Highlighter.vue?vue&type=script&lang=js"
export * from "./Highlighter.vue?vue&type=script&lang=js"
import style0 from "./Highlighter.vue?vue&type=style&index=0&id=5e852b18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e852b18",
  null
  
)

export default component.exports